module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABAUlEQVQ4T2P4//8/AwjX19f/JwJXAzFILQNMHwOyAT9//vz//ft3DPzjxw9kQ/JxGgACt27dwsAgAJMH0n+BOAmnAQ8ePMDAMAOQ8HecBrx+/RoDowOoWuwGvHv3DozvPb32/+jNzf/XnO77P3lf1v/y9Y7/s1caEDbg69evYBw+X+i/3yw2DEzQAFCIgzBIcdfu6P/LTjf/P3Bzxf+Hr28QZ8CfP3/AGKQYxkYWI2gADMAUYxOjvwFh0ACNXiRJ2AD0EAeB4vVW/yMWiPyfdjiHsAHBc3n/Z6zU+n/r1Sm4AX/+/vr//dfn///+/cVvACgz/fv3Dy8GqcFpACkYpg8AAvAYmxqc24kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/audio-x-generic.png
// module id = it5A
// module chunks = 1